import * as foundation from "./foundation"
import * as contextual from "./contextual"
import {
  createButton,
  createIconButton,
  createTextButton,
} from "../groupon/component/button"
import {
  createHeadingFontSizes,
  createHeadingLineHeights,
} from "../groupon/component/heading"
import {
  createTextFontSizes,
  createTextFontWeights,
  createTextLineHeights,
} from "../groupon/component/text"

export const button = createButton(foundation, contextual)
export const iconButton = createIconButton(foundation, contextual)
export const textButton = createTextButton(foundation, contextual)
export const headingFontSizes = createHeadingFontSizes(foundation, contextual)
export const headingLineHeights = createHeadingLineHeights(
  foundation,
  contextual,
)
export const textFontSizes = createTextFontSizes(foundation, contextual)
export const textFontWeights = createTextFontWeights(foundation, contextual)
export const textLineHeights = createTextLineHeights(foundation, contextual)
